<div id="layout-topbar" class="layout-topbar">
    <div class="layout-topbar-wrapper">
        <div class="layout-topbar-left">
            <a class="menu-button" href="javascript:;" *ngIf="false"
                (click)="appMain.onMenuButtonClick($event)" aria-label="Menu Toggle Button">
                <i class="pi pi-bars"></i>
            </a>
            <div class="layout-topbar-logo ml-2" id="logolink" style="cursor: pointer; outline: none;" routerLink="/user">
                <img src="../../../../../assets/layout/dfds-images/TopbarLogo/astro-logo.png" width="100" height="40" alt="cozmos-layout">

                <div class="environment" [ngClass]="logoClass">
                    <h5 class="mt-1">{{logoEnvironment}}</h5>
                </div>
            </div>
        </div>

        <div class="layout-topbar-right">
            <div>
                <h5 style="margin:0px;">{{viewInfo}}</h5>
                <p style="font-size: 12px;">{{menuTitle}}</p>
            </div>
            <a *ngIf="showRefreshButton" class="p-overlay-badge topbar-icon ml-2" (click)="sendRefreshClickEvent()"
                href="javascript:;" pTooltip="Refresh (Ctrl+R)" aria-label="Refresh the Current Page">
                <i class="fas fa-sync-alt" [@rotatedState]="rotateState"></i>
            </a>
            <ul class="layout-topbar-actions">
                <a href="javascript:;" class="p-overlay-badge topbar-icon " (click)="onClickShowAnnouncement()"  aria-label="Read Announcement">
                    <img *ngIf="isUnreadAnnouncement" class="announcement-icon p-0" alt="Announcement" pTooltip="Announcement(s)" pBadge src="../../../../../assets/layout/images/unread-announcement.PNG">
                    <img *ngIf="!isUnreadAnnouncement" class="blink-icon p-0" alt="announcement-blinking" pTooltip="Announcement(s)" pBadge src="../../../../../assets/layout/images/megaphone.gif">
                </a>
                <li #notifications class="topbar-item notifications"
                    [ngClass]="{'active-topmenuitem':appMain.activeTopbarItem === notifications}">
                    <ul class="fadeInDown">
                        <li class="layout-submenu-header">
                            <h6 class="header-text">Notifications</h6>
                              <span class="p-badge">{{notificationCount}}</span>
                        </li>
                        <li role="menuitem" *ngFor="let notification of notificationList">
                            <a href="javascript:;" (click)="appMain.onTopbarSubItemClick($event)"  aria-label="Menu Toggle Button" >
                                <i *ngIf="notification?.notificationType.includes('ETRACKER')" class="pi pi-envelope"></i>
                                <i *ngIf="notification?.notificationType.includes('DOCTRACKER')" class="pi pi-file"></i>
                                <div class="notifications-item" [pTooltip]="notification?.detail" (click)="onClickNavigateToNotification(notification?.id,notification?.notificationType,notification?.action)">
                                    <h6>{{notification?.title}}</h6>
                                    <span>{{notification?.notificationReceivedOn | date}} (UTC)</span>
                                </div>
                                <button pButton type="button" class="p-button-text p-button-danger h-1rem" (click)="onClickClearNotification(notification?.id)"  pTooltip="Clear"  tooltipPosition="top" icon="pi pi-trash" ></button>
                            </a>
                        </li>
              <li class="my-1 p-2" *ngIf="notificationList?.length==0" class="menuitem" style="text-align: center; display: block;">
                            <h6>No Notifications yet !</h6>
                            <img style="width: 100px;" src="../../../../../assets/layout/images/bell.gif"  alt="no-notifications" />
                        </li>
                        <div *ngIf="notificationList?.length!==0"  class="p-2 sticky-bottom">
                                <div class="flex justify-content-between">
                                    <button (click)="onClickNavigateToNotification()" pButton   class="cozmos-primary-button" label="Mark All as Read"></button>
                                    <button (click)="onClickClearNotification()" pButton   class="text-button ml-4" label="Clear All"></button>
                                </div>
                            </div>
                    </ul>

                </li>
                <li #profile class="topbar-item user-profile cursor-auto"
                    [ngClass]="{'active-topmenuitem':appMain.activeTopbarItem === profile}">
                    <a href="javascript:void();" class="cursor-auto" (click)="appMain.onTopbarItemClick($event,profile)"  aria-label="View User Profile">
                        <p-avatar [label]="firstLetter" styleClass="mr-2" shape="circle"></p-avatar>
                        <div class="profile-info">
                            <h6>{{userDetails?.first_name}} {{userDetails?.last_name}}</h6>
                            <span class="flex">{{userDetails?.role_name}}</span>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
        <p-dialog header="Announcements" [modal]="true" [resizable]="false" [draggable]="false"
            [(visible)]="showAnnouncement" styleClass="w-7">
            <div class="pb-0 announcement-dialog-box">
                <div class="details-relate-box mb-3" *ngIf="announcementList?.length>0">
                    <p-accordion [multiple]="true" *ngFor="let detail of announcementList;let i = index">
                        <p-accordionTab  [selected]="i === 0 ? true: false" >
                            <ng-template pTemplate="header">
                                <div class="displayContent">
                                    <div>{{detail?.title}}</div>
                                    <div *ngIf="detail?.file_available">
                                        <a href="javascript:;" aria-label="Download" class="ml-2" pTooltip="Download Attachment"
                                            (click)="downloadPDF(detail?.file_content, detail?.short_desc, detail?.id)" tooltipPosition="top">
                                            <i class="fas fa-download"></i>
                                        </a>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="content">
                                <div class="p-card-subtitle p-2" *ngIf="detail?.long_desc" >
                                    <div class="p-my-1"  [innerHTML]="detail?.long_desc | safeUrl:'html'"></div>
                                </div>
                            </ng-template>
                        </p-accordionTab>
                    </p-accordion>
                </div>
                <div class="details-relate-box mb-3" *ngIf="announcementList?.length==0">
                   <h4> There are No Announcements.</h4>
                 </div>
            </div>
        </p-dialog>
        <!-- ----------------logout confirmation modal----------- -->
        <p-dialog [(visible)]="logoutConfirmation" [closable]="true" [modal]="true" [draggable]="false"
            [resizable]="false" [style]="{width: '50vw'}" header="Logout Confirmation">
            <div>
                <span>
                    You are trying to logout from Astro application which uses SSO login.<br><br>
                    If you click on "YES" all your active sessions will be closed.
                    You still can close Browser/Tab to close the application.
                </span>
            </div>
            <hr />
            <div class="modalButtonAlign">
                <button pButton pRipple type="button" label="No" (click)="logoutConfirmation = false"
                    class="cozmos-secondary-button mr-2"></button>
                <button pButton pRipple type="button" label="Yes" class="cozmos-primary-button"
                    (click)="logOut()"></button>
            </div>
        </p-dialog>
    </div>
</div>
